import {
  canvasResolvedImages,
  canvasResolveImage,
} from 'tabview/canvasRendering/canvasResolvedImages';
import type { CanvasRenderingContext } from './types';

const drawImage = (
  ctx: CanvasRenderingContext,
  src: string,
  x: number,
  y: number,
  size: number
) => {
  canvasResolveImage({ isImage: true, value: src });
  const img = canvasResolvedImages.get(src);
  if (img?.complete) {
    const { naturalWidth, naturalHeight } = img;
    if (!naturalWidth || !naturalHeight) {
      // in Firefox, naturalWidth and naturalHeight will be zero if this image is an SVG with no height or width set on the root element.
      // Mozilla maintains this is not a bug. Chrome does some crazy gymnastics here, where it inspects the viewBox attribute and returns some token values which do respect the aspect ratio.
      // we're not going to do that here, because we'd have to re-fetch the image src as text and parse the viewBox out.
      // we're just going to draw the SVG as square.
      ctx.drawImage(img, x - size / 2, y - size / 2, size, size);
      return;
    }
    const isTall = naturalHeight > naturalWidth;
    const aspectRatio = naturalWidth / naturalHeight;
    const imageWidth = isTall ? size * aspectRatio : size;
    const imageHeight = isTall ? size : size / aspectRatio;
    ctx.drawImage(
      img,
      x - imageWidth / 2,
      y - imageHeight / 2,
      imageWidth,
      imageHeight
    );
  }
};
export { drawImage };
